import React from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});

export default function EditCost() {
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  const [Tug_data, setTug_data] = useState([]);
  const [Commodilist, setCommodilist] = useState([]);
  const [currency, setcurrency] = useState([]);
  let { id } = useParams();
  const classes = useStyles();
  const data_params = { CostId: id };

  const getcurrency = async () => {
    const data = await api.get(`api/master/currency`);
    const result = data?.data;
    setcurrency(result);
  };
  const getcosttype = async () => {
    const data = await api.get(`api/master/costtype`);
    const result = data?.data;
    setCommodilist(result);
  };

  const getData = async () => {
    try {
      const data = await api
        .post("api/cost/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              setTug_data(res);
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/Setting/EditCurrency");
                }
              });
            });
            // console.log("Nodata" + response);
          }
          //   console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    getcurrency();
    getcosttype();
    if (id) {
      getData();
    }
    // getlistcom()
    // console.log(id);
    // GET request using axios inside useEffect React hook

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          ต้นทุน
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Cost
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / {!id ? "Create Cost" : "Edit Cost"}
            </Typography>
          </Grid>
        </Grid>

        <Formik
          enableReinitialize
          initialValues={{
            code: Tug_data?.CostPrice ? Tug_data?.CostPrice : "",
            CostType: Tug_data?.CostType ? Tug_data?.CostType : "",
            CurrencyId: Tug_data?.CurrencyId ? Tug_data?.CurrencyId : "",
            Tug_name: Tug_data?.CostName ? Tug_data?.CostName : "",
            status: Tug_data?.Status ? (Tug_data?.Status === true ? 1 : 0) : 0,
            CostMAC5Code: Tug_data?.CostMAC5Code ? Tug_data?.CostMAC5Code : "",
            // CommodityId: Tug_data?.CommodityId ? Tug_data?.CommodityId: "",
          }}
          validate={(values) => {
            const errors = {};
            if (!values.Tug_name || values.Tug_name === "") {
              errors.Tug_name = "Required";
            }
            if (!values.code || values.code === "") {
              errors.code = " Required";
            }
            if (!values.CostType || values.CostType === "") {
              errors.CostType = " Required";
            }
            if (!values.CurrencyId || values.CurrencyId === "") {
              errors.CurrencyId = " Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              if (id) {
                const data = {
                  CostId: id,
                  CostName: values.Tug_name,
                  CostType: values.CostType,
                  CostPrice: +values.code,
                  CurrencyId: values.CurrencyId,
                  Status: values.status,
                  CostMAC5Code: values.CostMAC5Code
                };

                api
                  .post("/api/cost/update", data)
                  .then((respose) => {
                    const MySwal = withReactContent(Swal);

                    MySwal.fire({
                      icon: "success",
                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "สำเร็จ!",
                        "แก้ไขข้อมูลสำเร็จ !",
                        "success"
                      ).then((result) => {
                        if (result.isConfirmed) {
                          history.push("/Setting/Cost");
                        }
                      });
                    });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              } else {
                const data = {
                  CostId: "",
                  CostName: values.Tug_name,
                  CostType: values.CostType,
                  CostPrice: +values.code,
                  CurrencyId: values.CurrencyId,
                  CostMAC5Code: values.CostMAC5Code

                  // name: values.Tug_name,
                  // code: values.code,
                  // status: values.status,
                  // createId: EmpId,
                  // commodityId: values.CommodityId,
                };

                api
                  .post("/api/cost/create", data)
                  .then((respose) => {
                    const MySwal = withReactContent(Swal);

                    MySwal.fire({
                      icon: "success",
                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "สำเร็จ!",
                        "เพิ่มข้อมูลสำเร็จ !",
                        "success"
                      ).then((result) => {
                        if (result.isConfirmed) {
                          history.push("/Setting/Cost");
                        }
                      });
                    });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                {!id ? "ต้นทุน" : "แก้ไขต้นทุน"}
              </h6>
              <Grid container>
                <Grid item xs={4} sm={3} md>
                  <FormControl
                    style={{
                      width: "42%",
                      marginTop: "10px",
                      marginRight: "5px",
                      marginBottom: "10px",
                    }}
                    classes={{
                      root: !values.CostType ? classes.customOutline : null,
                    }}
                    required
                  >
                    <InputLabel id="select_status-label">CostType</InputLabel>
                    <Select
                      name="CostType"
                      value={values.CostType}
                      label="CostType"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      {Commodilist.map((x) => (
                        <MenuItem value={x.CostTypeId}>
                          {x.CostTypeName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <br />
                  <TextField
                    name="CostMAC5Code"
                    label="MAC-5 Code "
                    variant="outlined"
                    placeholder="MAC-5 Code "
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{
                      width: "42%",
                      marginBottom: "10px",
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={values.CostMAC5Code}
                  // classes={{ root: !values.factory_code ? classes.customOutline : null }}
                  // required
                  />
                  <br />
                  <TextField
                    name="Tug_name"
                    label="Cost Name"
                    variant="outlined"
                    placeholder="Cost Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{
                      width: "42%", marginBottom: "10px",
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={values.Tug_name}
                    classes={{
                      root: !values.Tug_name ? classes.customOutline : null,
                    }}
                    required
                  />

                  {/* {errors.Tug_name && touched.Tug_name&& errors.Tug_name} */}
                  <div style={{ display: "flex" }}>
                    <TextField
                      name="code"
                      label="Price"
                      variant="outlined"
                      placeholder="Price"
                      // type="number"
                      onChange={handleChange}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onBlur={handleBlur}
                      style={{ width: "20%", marginTop: "10px" }}
                      InputLabelProps={{ shrink: true }}

                      value={values.code}
                      classes={{
                        root: !values.code ? classes.customOutline : null,
                      }}
                      required
                    />
                    <FormControl
                      style={{
                        width: "21%",
                        marginTop: "10px",
                        marginLeft: "15px",
                      }}
                      classes={{
                        root: !values.code ? classes.customOutline : null,
                      }}
                      required
                    >
                      <InputLabel id="select_status-label">Currency</InputLabel>
                      <Select
                        name="CurrencyId"
                        value={values.CurrencyId}
                        label="Currency"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        {currency.map((x) => (
                          <MenuItem value={x.CurrencyId}>
                            {x.CurrencyCode}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  {id ? (
                    <div style={{ display: "flex" }}>
                      <FormControl fullWidth style={{ marginTop: "10px" }}>
                        <InputLabel id="select_status-label1">
                          Status
                        </InputLabel>
                        <Select
                          name="status"
                          id="status"
                          value={values.status}
                          label="Status"
                          style={{
                            width: "20%",

                            marginBottom: "10px",
                          }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        >
                          <MenuItem value={1}>Active</MenuItem>
                          <MenuItem value={0}>InActive</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                  marginTop: "15px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                  marginTop: "15px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
